var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 3,
    fill: "none",
    viewBox: "0 0 13 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M.96 2.368V.352h11.073v2.016H.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNegative);
export default __webpack_public_path__ + "static/media/icon_negative.fa3f0a30cce4c0f1e83465a1ceb90945.svg";
export { ForwardRef as ReactComponent };